import { render, staticRenderFns } from "./PickupLocationInfo.vue?vue&type=template&id=90fdcb20&scoped=true"
import script from "./PickupLocationInfo.vue?vue&type=script&lang=js"
export * from "./PickupLocationInfo.vue?vue&type=script&lang=js"
import style0 from "./PickupLocationInfo.vue?vue&type=style&index=0&id=90fdcb20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fdcb20",
  null
  
)

export default component.exports